import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import { getSVGImageUrl } from 'lib/imageUtils'
import BodyText from 'components/Luxkit/Typography/BodyText'

const Root = styled(LayoutContainer)`
  padding-top: ${rem(12)};
  padding-bottom: ${rem(12)};
  background-color: ${props => props.theme.palette.neutral.seven};
  display: flex;
  gap: ${rem(4)};
  justify-content: center;
`

interface Props {
  className?: string;
}

const AtolProtectedBanner = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { className } = props
  return (
    <div className={className} ref={ref}>
      <Root>
        <img src={getSVGImageUrl('984lj4elpskyg828z90qb')} width="16" height="16" alt=""/>
        <BodyText variant="small">ATOL protected</BodyText>
      </Root>
    </div>
  )
})

export default AtolProtectedBanner
